import React, { Component } from "react";
import LoadingOverlay from "react-loading-overlay";
import {
    Card,
    CardHeader,
    CardBody,
    Row,
    Col,
} from "reactstrap";
import { Input, Button } from "antd"
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import ScaleLoader from "react-spinners/ScaleLoader";
import List from 'react-smooth-draggable-list';
import { Scrollbars } from 'react-custom-scrollbars';
import { confirmAlert } from 'react-confirm-alert';
import SettingsService from '../../services/api/Setting';
import { toast } from 'react-toastify';
import { MenuNames } from "settings/shared/constants";
import { Select, Modal } from 'antd'
import WidgetsDataRender from "components/Settings/WidgetsDataRender";
import "../../assets/css/widgets.css"
import SelectWidgets from "components/Settings/SelectWidgets";
import { APIRESPONSE } from "settings/shared/constants";
import {
    PlusCircleOutlined
} from '@ant-design/icons';

class CustomMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            swidth: window.innerWidth,
            sheight: window.innerHeight,
            url: '',
            menuToken: '',
            menuId: '',
            menusList: [],
            addCustomMenu: false,
            customMenus: [],
            order: [],
            menuOptions: [],
            getMenuOptionList: [],
            errors: {
                embedUrl: ''
            },
            swidth: window.innerWidth,
            sheight: window.innerHeight,
            menuType: 'PowerBI',
            menuProps: [],
            SelectWidgetsList: [],
            ChooseMenuType : "Custom",
            layoutmenuName : "",
            isModalVisible: false,
            isMenuNameVisible : false,
            customMenuName: '',
            dashboardId: ''
        }
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

    }

    componentDidMount() {
        this.getMenuList();
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }


    updateWindowDimensions() {
        this.setState({ swidth: window.innerWidth, sheight: window.innerHeight });
    }

    getMenuList = () => {
        SettingsService.getMenuList()
            .then((response) => {
                if (response.status === APIRESPONSE.SUCCESS) {
                    let menuData = response.reorderMenus;
                    this.setState({
                        customMenus: response.customMenus === null ? [] : response.customMenus
                    }, () => {
                        this.updateMenuData(menuData);
                    })
                } else {
                    toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
                }
            })
    }

    getMenuOption = () => {
        SettingsService.getMenus()
            .then((response) => {
                if (response.status === APIRESPONSE.SUCCESS) {
                    let optionData = response.menuTypesDTO;
                    if (optionData !== null && optionData.length > 0) {
                        this.setState({
                            menuOptions: optionData
                        }, () => {
                            Promise.all([this.renderMenuListOptions(), this.getAttributes()]).then(values => {
                            })
                        })
                    }
                } else {
                    toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>)
                }
            })
    }

    renderMenuListOptions = () => {
        let option = this.state.menuOptions.map((item, index) => ({
            value: item.name,
            label: item.name
        }))
        if (this.state.menuOptions !== null && this.state.menuOptions.length > 0) {
            this.setState({
                getMenuOptionList: option
            })
        }
    }

    _removeWidget = () =>{
        this.getLayoutInfoById();
    }

    getAttributes = () => {
        SettingsService.getMenuProps(this.state.menuType)
            .then((response) => {
                if (response.status === APIRESPONSE.SUCCESS) {
                    this.state.elements = response;
                    let propsData = response.menuPropsDTOS !== null && response.menuPropsDTOS.length > 0 ? response.menuPropsDTOS : [];
                    this.dynamicInputFields(propsData);

                }
            })
    }

    dynamicInputFields = (data) => {
        if (data !== null && data !== undefined && data.length > 0) {
            let result = data.reduce(function (r, a) {
                r[a.category] = r[a.category] || [];
                r[a.category].push(a);
                return r;
            }, Object.create(null));
            this.state.menuProps = result
            this.setState({
                menuProps: result
            })
        }
    }

    handleChange = (id, event) => {
        const newElements = { ...this.state.elements }
        newElements.menuPropsDTOS.forEach(field => {
            const { elementType, key } = field;
            if (id === key) {
                switch (elementType) {
                    case 'checkbox':
                        field['fieldValue'] = event.target.checked;
                        break;

                    default:
                        field['fieldValue'] = event.target.value;
                        break;
                }
            }

        })
        this.dynamicInputFields(newElements.menuPropsDTOS);
    }

    handleAddInputFields = (e) => {
        e.preventDefault();
        let array = this.state.groupvalue.PowerBI;
        var result = Object.keys(array).map((key) => [array[key]]);
    }

    removeCustomMenuConfirmation = (item, removeIndex) =>{
        confirmAlert({
            title: "Confirm to Remove",
            message: 'Are you sure want to remove menu -' + item.name + '?',
            buttons: [{
                label: 'Yes',
                onClick: () => this.removeCustomMenu(item, removeIndex)
            },
            {
                label: 'No',
            }
            ]
        });
    }

    removeCustomMenu = (item, removedIndex) => {
        SettingsService.removeDashboardByName(item.name)
            .then((response) => {
                if (response.status === APIRESPONSE.SUCCESS) {
                    let orderArray = this.state.order;
                    let menuArray = this.state.menusList;
                    const orderIndex = orderArray.indexOf(removedIndex);
                    const menuIndex = menuArray.findIndex(menu => menu.name === item.name);
                    if (orderIndex > -1) {
                        orderArray.splice(orderIndex, 1); // 2nd parameter means remove one item only
                        for (let a = 0; a < orderArray.length; a++) {
                            orderArray[a] = a;
                        }
                    }
                    if (menuIndex > -1) {
                        menuArray.splice(menuIndex, 1); // 2nd parameter means remove one item only
                    }
                    this.setState({
                        order: orderArray,
                        menusList: menuArray
                    }, () => {
                        this.updateReorderMenus();
                    })
                }
            })
    }


    updateReorderConfirmation = () => {
        confirmAlert({
            title: "Confirm Reorder",
            message: 'Are you sure want to update menu orders?',
            buttons: [{
                label: 'Yes',
                onClick: () => this.updateReorderMenus()
            },
            {
                label: 'No',
            }
            ]
        });
    }

    updateReorderMenus = () => {
        let reOrderList = this.state.order.map(i => this.state.menusList[i]);
        let data = reOrderList.filter(item => item.name === MenuNames.PowerBI);
        let updateData = {
            accountId: localStorage.getItem("accountId"),
            customMenus: data !== null && data.length > 0 ? this.state.customMenus : [],
            reorderMenus: reOrderList
        }
        SettingsService.updateMenuList(updateData)
            .then((response) => {
                if (response.status === APIRESPONSE.SUCCESS) {
                    this.props.history.push('/auth/menu-settings');
                }
            })
    }

    revertOreder = () => {
        this.setState({
            addCustomMenu: false
        }, () => {
            this.getMenuList();
        })
    }

    openCustomMenu = () => {
        this.setState({
            addCustomMenu: true
        }, () => {
            this.getMenuOption();
        })
    }

    showModal = () => {
        this.setState({
            isModalVisible: true,
            layoutmenuName : ""
        },() => {
            this.getMenuOption();
        })
    }

    showMenuModalUpdate = () => {
        this.setState({
            layoutmenuName : this.state.customMenuName,
            isMenuNameVisible: true,
        })
    }

    onEditMenuName = (name) =>{
       this.showMenuModalUpdate();
    }

    handleCancelMenuModal = () => {
        this.setState({
            customMenuName : this.state.layoutmenuName,
            isMenuNameVisible: false
        })
    };

    updateMenuName = () =>{
        this.setState({
            isMenuNameVisible: false,
            customMenuName : this.state.customMenuName,
            layoutmenuName : this.state.customMenuName
        },()=>{
            SettingsService.updateMenuNameById(this.state.dashboardId, this.state.customMenuName)
            .then((response) => {
                if (response.status === APIRESPONSE.SUCCESS) {
                   this.setState({
                    customMenuName : response.menuName,
                    layoutmenuName : response.menuName
                   })
                }else{
                    toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
                }
            })
        })
    }

    handleCancel = () => {
        this.setState({
            isModalVisible: false
        })
      };

    closeCustomMenu = () => {
        this.setState({
            addCustomMenu: false
        })
    }

    updateMenuData = (menuData) => {
        if (menuData !== null && menuData.length > 0) {
            let orderArray = [];
            for (let a = 0; a < menuData.length; a++) {
                orderArray.push(a);
            }
            this.setState({
                order: orderArray,
                menusList: menuData
            })
        }
    }

    _getWidgets = (widgets) => {
        if(widgets !== undefined && widgets !== null && widgets.length > 0){
            let wData = {
                accountId : localStorage.getItem("accountId"),
                dashboardId : this.state.dashboardId,
                widgetType : widgets[widgets.length-1].widgetType
            }
            SettingsService.addWidgetByDashboard(wData)
            .then((response) => {
                if (response.status === APIRESPONSE.SUCCESS) {
                   this.getLayoutInfoById();
                }
            })
            
        }
    }

    getLayoutInfoById = () =>{
        SettingsService.getDashboardInfo(this.state.dashboardId)
            .then((response) => {
                if (response.status === APIRESPONSE.SUCCESS) {
                    let widgetsDTOS = response.widgetsDTOS;
                   if(widgetsDTOS !== null && widgetsDTOS.length > 0){
                      this.setState({
                        SelectWidgetsList : widgetsDTOS
                      })   
                   }else{
                    if(this.state.ChooseMenuType !== MenuNames.PowerBI){
                        this.setState({
                            SelectWidgetsList : []
                          })  
                    }else{
                        if(widgetsDTOS === null){
                        let wData = {
                            accountId : localStorage.getItem("accountId"),
                            dashboardId : this.state.dashboardId,
                            widgetType : MenuNames.PowerBI
                        }
                        console.log("ddfdf", wData.dashboardId)
                        SettingsService.addWidgetByDashboard(wData)
                        .then((response) => {
                            if (response.status === APIRESPONSE.SUCCESS) {
                               this.getLayoutInfoById();
                            }
                        })
                    }
                    }
                   }
                }
            })
    }

    _publishLayout = (widgetId, layoutData) => {
        let isValidForms = layoutData.filter(item => item.isValid === false);
        if (isValidForms !== null && isValidForms.length > 0) {
        } else {
            this.saveLayout(widgetId, layoutData);
        }
    }


    saveCustomMenu = (customMenuName) => {
        let tempList = this.state.menusList;
        tempList.push({
            name: customMenuName,
            displayName: customMenuName,
            customFlag : true
        })
        if (tempList !== null && tempList.length > 0) {
            let orderArray = [];
            for (let a = 0; a < tempList.length; a++) {
                orderArray = [...orderArray, a];
            }
            this.setState({
                order: orderArray,
                menusList: tempList
            }, () => {
                let reOrderList = this.state.order.map(i => this.state.menusList[i]);
                let updateData = {
                    accountId: localStorage.getItem("accountId"),
                    customMenus: [],
                    reorderMenus: reOrderList
                }
                SettingsService.updateMenuList(updateData)
                    .then((rest) => {
                        if (rest.status === APIRESPONSE.SUCCESS) {
                            this.getMenuList();
                        }
                    })
            })
        }
    }

    saveLayout = (widgetId, data) => {
        let layoutData = {
            accountId: localStorage.getItem("accountId"),
            dashboardId : this.state.dashboardId,
            widgetData: data
        }
        SettingsService.updateWidgetById(widgetId, layoutData)
            .then((response) => {
                if (response.status === APIRESPONSE.SUCCESS) {
                    toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Success</b></i>);
                    this.getLayoutInfoById();
                } else {
                    toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
                }
            })
    }

    saveMenus = () => {
        if (this.state.layoutmenuName === "" || this.state.layoutmenuName === undefined) {
            toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">Please Enter Menu Name</b></i>);
        } else {
            let customData = {
                accountId: localStorage.getItem("accountId"),
                menuName: this.state.layoutmenuName,
                menuType: this.state.ChooseMenuType,
            }
            SettingsService.saveCustomMenu(customData)
                .then((response) => {
                    if (response.status === APIRESPONSE.SUCCESS && response.dashboardInfoDTOs !== null && response.dashboardInfoDTOs.length > 0) {
                        let responseData = response.dashboardInfoDTOs[0];
                        this.setState({
                            isModalVisible: false
                        }, () => {
                            this.saveCustomMenu(responseData.menuName);
                            if (responseData.menuType === "Custom") {
                                toast.success(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">Custom Menu Created Successfully.</b></i>);
                            } else if (responseData.menuType === "PowerBI") {
                                this.setState({
                                    dashboardId: responseData.id
                                }, () => {
                                    this.addPowerBIWidgets();
                                })
                            }
                        })
                    } else {
                        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
                    }
                })
        }
    }

    addPowerBIWidgets = () => {
        let widgetData = [{
            widgetType: MenuNames.PowerBI
        }]
        this._getWidgets(widgetData);
        this.setState({
            isModalVisible: false
        });
        toast.success(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">PowerBI Menu Created Successfully.</b></i>);
    }

    getWidgetsByMenuName = (item, name) =>{
        SettingsService.getDashboardMenuName(name)
            .then((response) => {
                if (response.status === APIRESPONSE.SUCCESS && response.dashboardInfoDTOs !== null && response.dashboardInfoDTOs.length > 0) {
                    let dashboardData = response.dashboardInfoDTOs[0]
                    this.setState({
                        customMenuName: dashboardData.menuName,
                        dashboardId: dashboardData.id,
                        addCustomMenu: true,
                        SelectWidgetsList : [],
                        ChooseMenuType : dashboardData.menuType
                    },()=>{
                        this.getLayoutInfoById();
                    })
                }else{
                    toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
                }
            })
    }
    

    handleChangeMenuName = (event) => {
        event.preventDefault();
        this.setState({ layoutmenuName: event.target.value });
      }

    handleUpdateMenuName = (event) => {
    event.preventDefault();
    this.setState({ customMenuName: event.target.value });
    }

    getCustomData = () => {
        if (this.state.customMenus !== undefined && this.state.customMenus !== null && this.state.customMenus.length > 0) {
            let customData = this.state.customMenus[0].menuData;
            this.setState({
                url: customData.embedUrl,
                menuToken: customData.token,
                menuId: customData.powerid,
                addCustomMenu: true,
            })
        }
    }

    resetData = () => {
        this.setState({
            url: '',
            menuToken: '',
            menuId: ''
        })
    }

    handleChangeChooseMenu = (value) => {
        this.setState({
            ChooseMenuType : value
        })
    }

    redirectToMenu = () =>{
        window.location.reload();
        this.props.history.push('/auth/menu-settings');
    }

    render() {
        const { errors } = this.state;
        return (
            <>
                <PanelHeader
                    content={
                        <div className="header text-center">
                        </div>
                    }
                />
                <div className="content">
                    <LoadingOverlay active={this.state.loading} spinner={<ScaleLoader height={35} width={5} radius={2}
                        margin={2} color={"#123abc"} loading={this.state.loading} />}
                    >
                        <Row>
                            <Col xs={12} md={12}>
                                <Card>
                                    <CardHeader>
                                        <Row>
                                            <Col xs={12}>
                                                <div className="d-flex justify-content-between">
                                                    <span className="mb-3 d-block pl-3"><b>Custom Menu  &nbsp;&nbsp;<span className="text-primary font16 actionicon font-weight-bold" onClick={this.showModal}>
                                                        <PlusCircleOutlined /> </span></b></span>
                                                    {this.state.addCustomMenu === true ? <Button type="primary" className='float-right' onClick={e => this.redirectToMenu()}
                                                        size="middle"
                                                    > Publish Menu</Button> : ''}
                                                </div>
                                            </Col>
                                            <Col xs={12} lg={3}>                                 
                                                <CardBody className="create-new-user">
                                                    <Scrollbars autoHeight autoHeightMin={this.state.sheight - 200}>
                                                        <div className="carcontent">
                                                            <div className="custom-menus">

                                                                <b className="d-block mb-3">Reorder Menus</b>
                                                                <div className="sub-block">
                                                                    <List
                                                                        rowHeight={40}
                                                                        gutter={10}
                                                                        order={this.state.order}
                                                                        onReOrder={order => this.setState({ order })}>
                                                                        {this.state.menusList.length > 0 ? this.state.menusList.map((item, index) => (
                                                                            <List.Item className="re-order-menu" key={index} id={item.name}>{item.displayName === "PowerBI" ? "Dashboard" : item.displayName}
                                                                                <p className="m-0">{item.customFlag ? <span className="pointercursor mr-3 actionicon" onClick={() => this.getWidgetsByMenuName(item, item.name)}><i className="fas fa-edit" /></span> : ''} {item.customFlag && <i className="fas fa-times actionicon"
                                                                                    onClick={e => this.removeCustomMenuConfirmation(item, index)} />}</p>
                                                                            </List.Item>
                                                                        )) :
                                                                            <List.Item className="re-order-menu">No Menus</List.Item>
                                                                        }
                                                                    </List>
                                                                </div>
                                                            </div>
                                                            <div className="mt-2">
                                                                <Button type="ghost" className="mr-2"
                                                                    onClick={this.revertOreder}>Cancel</Button>
                                                                <Button type="primary" className={this.state.menusList.length === 0 ? "primary disabled" : "primary"}
                                                                    onClick={this.updateReorderConfirmation}>Update</Button>
                                                            </div>
                                                        </div>
                                                    </Scrollbars>
                                                </CardBody>
                                            </Col>

                                            <Modal title="Add Custom Menu" visible={this.state.isModalVisible} 
                                                onCancel={this.handleCancel}
                                                footer={[
                                                    <Button key="back" className="btn-light" onClick={this.handleCancel}>
                                                        Cancel
                                                    </Button>,
                                                    <Button key="submit" type="primary" className="btn-primary ml-3" onClick={this.saveMenus}>
                                                        Save
                                                    </Button>
                                                ]}
                                            >
                                                <Row>
                                                    <Col sm={12} className="mb-3">
                                                        <label
                                                            className="form-control-label font12"
                                                        >
                                                            Choose Menu
                                                        </label> <br />
                                                        <Select
                                                            className='select-theme-width'
                                                            value={this.state.ChooseMenuType}
                                                            onChange={this.handleChangeChooseMenu}
                                                            options={this.state.getMenuOptionList} />
                                                    </Col>

                                                    <Col sm={12} className="mb-3">
                                                        <label
                                                            className="form-control-label font12"
                                                        >
                                                            Menu Name
                                                        </label> <br />
                                                        <Input placeholder='Menu Name' className='select-theme-width'
                                                            value={this.state.layoutmenuName}
                                                            onChange={this.handleChangeMenuName} />
                                                    </Col>
                                                </Row>
                                            </Modal>


                                            <Modal title="Update Menu" visible={this.state.isMenuNameVisible} 
                                                onCancel={this.handleCancelMenuModal}
                                                footer={[
                                                    <Button key="back" className="btn-light" onClick={this.handleCancelMenuModal}>
                                                        Cancel
                                                    </Button>,
                                                    <Button key="submit" type="primary" className="btn-primary ml-3" onClick={this.updateMenuName}>
                                                        Update
                                                    </Button>
                                                ]}
                                            >
                                                <Row>

                                                    <Col sm={12} className="mb-3">
                                                        <label
                                                            className="form-control-label font12"
                                                        >
                                                            Menu Name
                                                        </label> <br />
                                                        <Input placeholder='Menu Name' className='select-theme-width'
                                                            value={this.state.customMenuName}
                                                            onChange={this.handleUpdateMenuName} />
                                                    </Col>
                                                </Row>
                                            </Modal>


                                            {this.state.addCustomMenu === true ?
                                                <Col xs={12} lg={9}>
                                                    <CardBody className="create-new-user padding-setting">
                                                        <Scrollbars autoHeight autoHeightMin={this.state.sheight - 200}>

                                                            {this.state.ChooseMenuType === "Custom" && <div>
                                                            <span><b>Menu Name :</b> {this.state.customMenuName} </span>
                                                            <span className="d-block float-right" onClick={this.closeCustomMenu}><i className="fas fa-times actionicon" /></span>
                                                            <Row>
                                                                <Col>
                                                                    <SelectWidgets
                                                                        _getWidgets={this._getWidgets.bind(this)}
                                                                        dashboardWidgets = {this.state.SelectWidgetsList}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                            <WidgetsDataRender widgetsList={this.state.SelectWidgetsList} 
                                                            _removeWidget = {this._removeWidget.bind(this)}
                                                            _publishLayout={this._publishLayout.bind(this)} />

                                                            </div>}

                                                            {this.state.ChooseMenuType === "PowerBI" && <div className="carcontent">
                                                                <span><b>Menu Name :</b> {this.state.customMenuName} </span>
                                                                <WidgetsDataRender widgetsList={this.state.SelectWidgetsList} 
                                                                _publishLayout={this._publishLayout.bind(this)} />
                                                                
                                                            </div>}
                                                        </Scrollbars>
                                                    </CardBody>
                                                </Col>
                                                : ''}
                                        </Row>
                                    </CardHeader>
                                </Card>
                            </Col>
                        </Row>
                    </LoadingOverlay>
                </div>
            </>
        );
    }
}

export default CustomMenu;